module.exports = __webpack_public_path__ + "img/logo2.24b0b72b.svg";